// extracted by mini-css-extract-plugin
export var box = "_4n-0";
export var check = "_4n-1";
export var checkboxButton = "_4n-6";
export var checkboxGroup = "_4n-5";
export var disabled = "_4n-7";
export var ghost = "_4n-9";
export var input = "_4n-2";
export var label = "_4n-4";
export var normal = "_4n-8";
export var uncheck = "_4n-3";